import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { StatementReportComponent } from '@pg-app/client/statement-report/statement-report.component';
import { StatementReportRoutingModule } from '@pg-app/client/statement-report/statement-report-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { CsvElementsToIncludeClientStatementComponent } from './csv-elements-to-include-client-statement/csv-elements-to-include-client-statement.component';

@NgModule({
  imports: [
    CommonModule,
    CoreUiModule,
    CoreMaterialModule,
    ReactiveFormsModule,
    NgTableModule,
    StatementReportRoutingModule,
    DragDropModule,
    CommonDialogModule,
    PipeModule
  ],

  declarations: [StatementReportComponent, CsvElementsToIncludeClientStatementComponent],
})
export class StatementReportModule { }
